import { render, staticRenderFns } from "./photograph.vue?vue&type=template&id=1c9278f6&"
import script from "./photograph.vue?vue&type=script&lang=js&"
export * from "./photograph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports